import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { IconPlayerPlayFilled } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import defaultImage from "../../../assets/images/default.jpg";
import LazyImage from '../../../common/ImageFallback';
import { usePermission } from '../../../hooks/usePermission';
import { permissionError, warning, warningAccept } from '../../../util/Alert';
import Iconb from '../../extra/Iconb';
import ImagePreviewModal from '../../extra/ImagePreviewModal';
import Pagination from '../../extra/Pagination';
import ShowVideo from '../../extra/ShowVideo';
import Table from '../../extra/Table';
import { deleteVideoReport, getVideoReport, resolveReport } from '../../store/videoReport/videoReport.action';

const VideoReport = () => {

    const dispatch = useDispatch();

    const { can } = usePermission();
    const canCreate = can("Reels Report", "Create");
    const canDelete = can("Reels Report", "Delete");
    const canEdit = can("Reels Report", "Edit");

    const { videoReport, totalReportReels } = useSelector((state) => state.videoReport);

    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(true);
    const [type, setType] = useState("All");

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [show, setShow] = useState(false);
    const [url, setUrl] = useState();
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    useEffect(() => {
        dispatch(getVideoReport(type, currentPage, rowsPerPage));
    }, [type, currentPage, rowsPerPage, type])

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        setData(videoReport);
    }, [videoReport]);

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event, 10);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [type]);


    const handleClick = (reportId) => {
        warningAccept()
            .then((isDeleted) => {
                if (!isDeleted) return;
                if (!hasPermission) return permissionError();
                dispatch(resolveReport(reportId));
            })
            .catch((err) => console.log(err));
    };

    const handleDecline = (reportId, reelId) => {
        warning()
            .then((isDeleted) => {
                if (!isDeleted) return;
                if (!hasPermission) return permissionError();
                dispatch(deleteVideoReport(reportId, reelId));
            })
            .catch((err) => console.log(err));
    };

    const handleClose = () => {
        setShow(false);
        setUrl("");
    };

    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) => (
                <span className="text-white">
                    {(currentPage - 1) * rowsPerPage + index + 1}
                </span>
            ),
        },

      

        {
            Header: "VIDEO",
            body: "video",
            Cell: ({ row, index }) => (
                <>
                    <div
                        className="d-flex justify-content-center"
                        onClick={() => {
                            setShow(true);
                            setUrl(row?.reelId?.video);
                        }}
                    >
                        {/* <HandleVideo thumbnail={row?.videoImage} videoUrl={row?.videoUrl} /> */}

                        <div
                            style={{
                                position: "relative",
                                width: "50px",
                                height: "50px",
                                cursor: "pointer",
                            }}
                        >
                            <IconPlayerPlayFilled
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)", // centers it
                                    zIndex: 1,
                                    fontSize: "20px", // adjust size as needed
                                    color: "white", // optional: make it visible
                                }}
                            />
                            <LazyImage
                                imageSrc={row?.reelId?.thumbnail}
                                width="50px"
                                height="50px"
                                style={{ filter: "brightness(0.5)" }}
                            />
                        </div>
                    </div>
                </>
            ),
        },
        

        {
            Header: "User",
            body: "images",
            Cell: ({ row }) => (
                <div className="d-flex justify-content-start " style={{ paddingLeft: "10px" }}>
                    <div className="">
                        <img
                            src={row?.userId?.image}
                            height={55}
                            width={55}
                            style={{ borderRadius: "10px", cursor: "pointer" }}
                            alt=""
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!row?.userId?.image) return;
                                setSelectedImage(row.userId.image);
                                setShowImageModal(true);
                            }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = defaultImage;
                            }}
                        />
                    </div>
                    <span className="fw-normal boxCenter text-start ms-2 text-white">
                        {row?.userId ? row?.userId?.firstName + " " + row?.userId?.lastName : ""}
                    </span>
                </div>
            ),
        },

        {
            Header: "Description",
            body: "description",
            Cell: ({ row }) => (
                <div className="">
                    <p className="mb-0 fw-normal text-white">
                        {row?.description
                        }
                    </p>
                </div>
            ),
        },

        {
            Header: "Status",
            body: "status",
            Cell: ({ row }) => (
                <div className="">
                    <p className="mb-0 fw-normal text-white">{row?.status === 1 ? "Pending" : "Solved"}</p>
                </div>
            ),
        },

        {
            Header: "Video reported",
            body: "videoReported",
            Cell: ({ row }) => (
                <div className="">
                    <p className="mb-0 fw-normal text-white">{row?.reportDate?.split(",")[0]}</p>
                </div>
            ),
        },

        {
            Header: "Action",
            body: "",
            Cell: ({ row }) => {
                if (row?.status === 2) {
                    return (
                        // <div
                        //     style={{
                        //         color: "#2f2b3de6",
                        //         fontWeight: "bold",
                        //         textAlign: "center",
                        //         width: "80px",
                        //         margin: "auto",
                        //         userSelect: "none",
                        //     }}
                        // >
                        //     Solved
                        // </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                            <Iconb
                                newClass={`themeFont boxCenter killbtn userBtn fs-5`}
                                btnIcon={<CancelIcon sx={{ color: "red" }} />}
                                style={{
                                    borderRadius: "5px",
                                    width: "40px",
                                    color: "red",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    handleDecline(row?._id, row?.reelId?._id);
                                }}
                            />
                        </div>
                    );
                }
                return (
                    <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                        <Iconb
                            newClass={`themeFont boxCenter acptbtn userBtn fs-5`}
                            btnIcon={<CheckCircleIcon sx={{ color: "green" }} />}
                            style={{
                                borderRadius: "5px",
                                width: "40px",
                                color: "green",
                                cursor: "pointer",
                            }}
                            onClick={() => handleClick(row?._id)}
                        />

                        <Iconb
                            newClass={`themeFont boxCenter killbtn userBtn fs-5`}
                            btnIcon={<CancelIcon sx={{ color: "red" }} />}
                            style={{
                                borderRadius: "5px",
                                width: "40px",
                                color: "red",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                handleDecline(row?._id, row?.reelId?._id);
                            }}
                        />
                    </div>
                );
            }
        }



    ];
    return (
        <>
            <ShowVideo
                title={"Video"}
                show={show}
                url={url}
                handleClose={handleClose}
            />
            <div className="mainSellerTable">
                <div className="sellerTable">
                    <div className="col-12 headname">Reels Report</div>
                    <div className="sellerMain">
                        <div className="tableMain mt-2 categoryTable">
                            <div className="sellerHeader primeHeader">
                                <div className="row mb-3" >
                                    {/* Left side - Transaction Type Dropdown */}
                                    <div className="col-6" style={{ display: "flex", alignItems: "center" }}>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn btnnewPrime dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                style={{
                                                    borderRadius: "5px",
                                                    padding: "8px 40px",
                                                    background: "#fff",
                                                    marginLeft: "5px"
                                                }}
                                            >
                                                {type ? (
                                                    <span className="caret text-black">{type === "All"
                                                        ? "All"
                                                        : type === "1"
                                                            ? "Pending"
                                                            : type === "2"
                                                                ? "Solved"
                                                                : "Type"
                                                    }
                                                    </span>
                                                ) : (
                                                    <span className="caret text-capitalize">Type</span>
                                                )}
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li style={{ cursor: "pointer" }}>
                                                    <a
                                                        className="dropdown-item"
                                                        href={() => false}
                                                        onClick={() => setType("All")}
                                                    >
                                                        All
                                                    </a>
                                                </li>
                                                <li style={{ cursor: "pointer" }}>
                                                    <a
                                                        className="dropdown-item"
                                                        href={() => false}
                                                        onClick={() => setType("1")}
                                                    >
                                                        Pending
                                                    </a>
                                                </li>
                                                <li style={{ cursor: "pointer" }}>
                                                    <a
                                                        className="dropdown-item"
                                                        href={() => false}
                                                        onClick={() => setType("2")}
                                                    >
                                                        Solved
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <Table
                                data={data}
                                mapData={mapData}
                                serverPerPage={rowsPerPage}      // Direct use
                                serverPage={currentPage}        // Direct use
                                type={"server"}
                                loading={loading}
                                shimmer={true}
                            />
                            <Pagination
                                component="div"
                                count={totalReportReels}
                                type={"server"}
                                onPageChange={handleChangePage}
                                serverPerPage={rowsPerPage}
                                totalData={totalReportReels}
                                serverPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </div>
                    <div className="sellerFooter primeFooter"></div>
                </div>
            </div>
            <ImagePreviewModal
                isOpen={showImageModal}
                onClose={() => {
                    setShowImageModal(false);
                    setSelectedImage("");
                }}
                image={selectedImage}
            />
        </>
    )
}

export default VideoReport